// extracted by mini-css-extract-plugin
module.exports = {"lightPopconfirm":"LrvPopconfirm_lightPopconfirm__2veiW","darkPopconfirm":"LrvPopconfirm_darkPopconfirm__2di7I"};